module.exports = __webpack_public_path__ + "static/img/2-18-漏发补发问题类型.8feda28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/ppt/2-18-漏发补发问题类型.png
// module id = 1353
// module chunks = 0